'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

exports.default = _react.PropTypes.oneOf(['topleft', 'topright', 'bottomleft', 'bottomright']);


//////////////////
// WEBPACK FOOTER
// ./~/react-leaflet/lib/types/controlPosition.js
// module id = 156
// module chunks = 0